package alltravelagents

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class AllTravelAgentsState(
    val getAllTravelAgents: PaginationState<TravelAgentModel> = PaginationState(),
)
